import img271 from '@/assets/2-7-1.png';
import img272 from '@/assets/2-7-2.png';
import img273 from '@/assets/2-7-3.png';
import img274 from '@/assets/2-7-4.png';
import img275 from '@/assets/2-7-5.png';

export default [
  {
    version: 'v2.7',
    date: '2025/12/12',
    content: `
      <div class="content">
  各位葱花投研的用户，本产品目前正式更新为完整的v2.7版本，对于期间大部分机构客户提出的建议，我们增加了较多的数据，提升了部分算法，并且加快了体验速度与数据颗粒度，本轮更新的主要调整部分如下：
  <br />
  <span>所有页面增加了对应的数据标注体系，对应的数据口径与定义有所显示</span>
  <br />
  <span>大类及行业部分：</span>
  <br />
  1.Dashboard大类资产板块：
  <div class="s_t">1.1 多资产类别对比<span>增加了Sharp Ratio的计算，并可以选择对应的无风险利率；</span></div>
  2.市场快报板块：
  <div class="s_t">2.1 优化了日内走势板块，板块细分内容包括：</div>
  <div class="s_t">
    指数增加了<span>对应同时间段的自制全市场REITs指数，同步供参考</span>；
  </div>
  <img data-preview src="${img271}" />
  2.2 分红情况板块：<br />
  优化了分红板块的数据，增加了<span
    >基准日、可供尚未分配金额（万元）、可供尚未分配收益率（%）</span
  ><br />
  <span>增加了以金额为单位的统计方式，以便于计算汇总;</span>
  <img data-preview src="${img272}" />
  <br />
  <span>个股部分（重大更新）：</span><br />
  1.增加了：<span>总REITs列表 + 自选股板块</span>
  <img data-preview src="${img273}" />
  2.增加了：<span>自选板块可自制指数</span>
  <img data-preview src="${img274}" />
  3.增加了每一个前述页面菜单，<span>均可以直接勾选自选组合</span>
  <img data-preview src="${img275}" />
</div>
    `,
  },
  {
    version: 'v2.6',
    date: '2025/08/20',
    content: `<div class="content">
  各位葱花投研的用户，本产品目前正式更新为完整的v2.6版本，对于期间大部分机构客户提出的建议，我们增加了较多的数据，提升了部分算法，并且加快了体验速度与数据颗粒度，本轮更新的主要调整部分如下：
  <br/>
  <span>所有页面增加了对应的数据标注体系，对应的数据口径与定义有所显示</span>
  <br>
  <br>
  <span>大类及行业部分：</span>  
  <br>
  1.Dashboard大类资产板块：
  <div class="s_t">1.1增加了Yield Spread板块中可以<span>选择个股进行对比</span>；</div>
  2.市场快报板块：
   <div class="s_t">
    2.1 优化了<span>日内走势板块</span>，板块细分内容包括：
    <br/>
    增加了<span>分板块指数对应的树状图方块</span>；
    <br>
    增加了日内的<span>点击分板块</span>后的<span>个股日内指数走势</span>；
    <br>
    2.2 优化了<span>日内收益板块的部分，</span>
    <br>
    增加了<span>自定义时间的收益率，供客户自主选择收益率</span>；
    <br>
    增加了<span>日内实时换手率，以便于对比日内成交情况</span>；
   </div>
  3.底层资产板块 ：
  <div class="s_t">
    <div class="row underline">
    增加了经营数据多指标下载功能
    </div>
    3.2 底层资产 – 运营数据：<span class="underline">增加了推算指标的定义、推算数据标蓝提示，可以根据需要选择原始与推算 </span>；
  </div>
  4.财报分析板块：
  <div class="s_t">
    4.1 完成率部分：<span class="underline">增加了原有财报IPO数值的直接下载，以及对应年化可选功能</span>；
    <br>
    4.2 Yield传递分析 - 增加了<span class="underline">使用目前ev/市值重新计算功能，以便于获取最新waterfall</span>
  </div>
  5.估值分析板块：
  <div class="s_t">
    <span class="underline">增加了在IPO财报中对应的预测期分派率、预期期EV/EBITDA指标，IRR/NPV计算提前至上市后连续计算；</span>
  </div>
  6.趋势洞察板块：
  <div class="s_t">
    <span class="underline">增加了发行溢价率、IPO参考杠杆率在整张表格可以下载；</span>
  </div>
  <br>
  <span>个股部分：</span>
  <br>
  1.财报数据：
  <br>
  <span>个股财务报表目前优化单项目公司对应财报；</span>
  <br>
  2.估值数据：
  <br>
  <span>个股历史估值，选择分派率、EV/EBITDA可以计算对应的历史时间段倍数；</span>
  <br>
  <span>并且提示部分增加了预测表的数据，作为参考线</span>
</div>`,
  },
  {
    version: 'v2.4.2',
    date: '2025/06/23',
    content: `<div class="content">
      各位葱花投研的用户，本产品目前正式更新为完整的v2.4版本，对于期间大部分机构客户提出的建议，我们增加了较多的数据，提升了部分算法，并且加快了体验速度与数据颗粒度，本轮更新的主要调整部分如下：
      <br />
      <span>大类及行业部分：</span>
      <br />
      1.Dashboard大类资产板块：
      <div class="s_t">1.1 增加了自定义时间选择范围；</div>
      2.市场快报板块：
      <div class="s_t">
        2.1 优化了<span>日内走势板块</span>，板块细分内容包括；<br />
        增加了中证REITs（全收益）的不同频率K线；<br />
        增加了日内的<span>分板块指数走势</span>；<br />
        2.2 优化了<span>分红情况板块</span>，板块细分内容包括：<br />
        <span>增加了可以按照月度对比计数的考虑；</span><br />
        <span>对比按业态/个券/管理人的统计了不同时间分红；</span>
      </div>
      3.市场动态板块<span>（重大更新）</span>：
      <div class="s_t">
        <span style="text-decoration:underline;text-underline-offset:4px">增加了各个板块的自定义日期选择功能</span><br />
        3.2 底层资产 – 运营数据：<span
          >增加了产业园、物流、消费、保租房、高速公路及能源，</span
        ><br />
        <span>6大板块的多指标运营数据，并可以横向折现/柱状图对比及下载</span>；
      </div>
      4.估值分析板块：<br />
      <div class="s_t">无较大更新;</div>
      5.趋势洞察板块：<br />
      <div class="s_t">
        5.1 增加了历史的认购倍数相关数据的下载：<br />
        <span>增加了历史的认购倍数可以整张表格下载；</span><br />
        <span>网下认购比例部分增加了剔除无效报价、最终报价等口径；</span>
      </div>
      <span>个股部分：</span><br />
      6.运营数据<span>（重大更新）</span>：<br />
      <span>个股财务报表目前增加单项目公司对应财报</span>
    </div>`,
  },
  {
    version: 'v2.4',
    date: '2025/05/18',
    content: `    <div class="content">
      各位葱花投研的用户，本产品目前正式更新为完整的v2.4版本，对于期间大部分机构客户提出的建议，我们增加了较多的数据，提升了部分算法，并且加快了体验速度与数据颗粒度，本轮更新的主要调整部分如下：
      <br />
      <span>大类及行业部分：</span>
      <br />
      1.Dashboard大类资产板块：
      <div class="s_t">1.1 提示部分增加了流通市值位置显示；</div>
      2.市场快报板块：
      <div class="s_t">
        2.1 增加了<span>投资人结构板块</span>，板块细分内容包括：
        <br />
        <span>对比全部板块的投资人结构够构成；</span><br />
        <span>对比按业态/个券的投资人构成；</span><br />
        <span>对比各个机构汇总后，对应的业态及个券构成；</span><br />
        2.2 日内的个股数据的部分增加了筛选功能；
      </div>
      3.底层板块<span>（重大更新）</span> ：
      <div class="s_t">
        3.1 底层资产 –
        资产列表：<span>增加了所有资产的编号及资产列表可供下载</span>；
        <br />
        3.2 底层资产 –
        运营数据：增加了<span>产业园、物流、消费、保租房、高速公路及能源</span>，
        <br />
        <span> 6大板块的多指标运营数据，并可以横向折现/柱状图对比及下载；</span>
      </div>
      4.估值分析板块：
      <div class="s_t">无较大更新;</div>
      5.趋势洞察板块<span>（重大更新）</span> ：
      <div class="s_t">
        5.1 增加了REITs日历功能，可<span>快捷了解</span>
        <br />
        <span
          >项目动态(申报、反馈、问询、回复、通过、即将上市等多种状态更新时间);</span
        ><br />
        <span>解禁（集中解禁时间及单次解禁份额）;</span><br />
        <span>分红（公告日、登记日、除权日、支付日）</span><br />
       5.2 增加了所有公告列表，以便于跨板块及同类型的公告可以集中阅读及下载；
      </div>
      <span>个股部分：</span>
      <br/>
      6.运营数据<span>（重大更新）</span>：
      <br />
      <span
        >消费、保租房及能源板块，目前已经集中更新，并根据单个业态特质增加了对应的预测板块</span
      >
      <br />
      <span>后续更新预期：</span>
      <br />
      7.个股（财报部分）：由于2025Q1部分财报结构变化，后续将增加部分项目公司财报；<br />
      8.趋势洞察板块 – 发行动态，将增加所有个券历史发行动态的下载功能；<br />
      9.市场动态板块 – 日内走势部分将增加分业态的日内板块走势图；<br />
      10.部分页面将逐步增加，可选的开始时间及结束时间选择；
    </div>
    `,
  },
  {
    version: 'v2.2',
    date: '2025/02/18',
    content: `<div class="content">
      各位葱花投研的用户，本产品目前正式更新为完整的v2.2版本的提升，对于期间大部分机构客户提出的建议，我们增加了较多的数据，提升了部分算法，并且加快了体验速度与数据颗粒度，本轮更新的主要调整部分如下：<br/>
      <br/>
      <span>新增板块大类——市场动态（本次主要重大更新！）：</span>
      <div>2.1 日内走势提示：</div>
      <div class="s_t">
        <span>2.1.1 中证REITs全收益指数 - 增加日内分比成交板块；</span><br/>
        <span>2.1.2 中证REITs全收益指数 - 增加日内走势分钟线及对应的领跌领涨板块；</span><br/>
        <span>2.1.3 中证REITs全收益指数 - 增加日内实时倍数及分派率；</span><br/>
        <span>2.1.4 公募REITs日内涨跌幅排行</span><br/>
      </div>
      <div>2.2 日内收益板块：</div>
      <div class="s_t">
        2.2.1 增加了<span>大类板块的，日内实时收益表现、实时分派率，并可以排序；</span><br/>
        2.2.2 增加了<span>个股板块的，日内实时收益表现、实时分派率，并可以排序；</span>
      </div>
      <div>2.3 分红板块汇总：</div>
      <div class="s_t">
        2.3.1 对于近3个月的分红情况进行汇总，<span>提示了单次分红收益率，及对应时间段分红次数等，以便于帮助投资者可以快速的了解实际分红情况</span><br/>
        <span>2.3.2 展示了分板块，分年份的平均分红次数汇总，以帮助投资者更快捷的捕捉分红策略机会；</span>
      </div>
      <div>2.4 交易排名：</div>
      <div class="s_t">
        2.4.1 增加了不同时间段，大类、个股的交易情况<span>（成交额、大宗成交额、换手率、资金净流入、主力资金净流入、主力主动资金净流入）</span>排名的快捷排序/筛选；<br/>
        2.4.2 增加了不同时间段，大类、个股的<span>大宗交易</span>明细表格；
      </div>
      <br/>
      <span>历史版本v2.1 优化：</span>
      <div>1.Dashboard大类资产板块：</div>
      <div class="s_t">
        <span>1.1 首页增加了大类资产比较，可以选择不同时间段/年份</span>
      </div>
      <div>2. 市场走势板块<span>（重大更新）</span>：</div>
      <div class="s_t">
        2.1-2.3 每个板块均增加了：<span>1D,1W,1M时间段，以便于周报月报日报的撰写；</span><br/>
        <span>2.1-2.3 每个板块均增加了：年份筛选，可以筛选2021-2024以来的每个年份</span>
      </div>
      <div>3.财报板块：</div>
      <div class="s_t">
        	3.1 waterfall 分析板块<span>开放了股的waterfall的选择</span>；
      </div>
      <div>4. 估值分析板块（重大更新）：</div>
      <div class="s_t">
        IRR/NPV 板块<span>新增了自定义按钮</span>，可以筛选：要求回报、增速自调、退出年份自调、退出折现率等多种参数；
      </div>
    </div>`,
  },
];
